import React, { useEffect } from "react";
import "./style.css";

const Backdrop = () => {
  useEffect(() => {
    const canvas = document.getElementById("c");
    const ctx = canvas.getContext("2d");

    // Making the canvas full screen
    canvas.height = window.innerHeight;
    canvas.width = window.innerWidth;

    const text = "#SAVEJAMES"; // Text to drop
    const fontSize = 16;
    const columns = Math.floor(canvas.width / fontSize); // Ensure integer value for columns
    const drops = Array(columns).fill(0); // Initialize drops for each column

    // Drawing the characters
    const draw = () => {
      // Black background with translucent effect to show trails
      ctx.fillStyle = "rgba(255, 255, 255, 0.04)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#f7aa83"; // Pink text color
      ctx.font = fontSize + "px arial";

      for (let i = 0; i < drops.length; i++) {
        // Draw a single character from the text
        const character = text[i % text.length];
        ctx.fillText(character, i * fontSize, drops[i] * fontSize);

        // Reset drop position randomly after it crosses the screen
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }

        // Incrementing the Y coordinate
        drops[i]++;
      }
    };

    const interval = setInterval(draw, 100);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  return <canvas id="c" style={{ display: "block", background: "white" }} />;
};

export default Backdrop;
